import React from 'react';
import { wrap, INK, GREY, FONT } from '../seo/SeoUI';
import FaqAccordion from '../../components/Faq/FaqAccordion';
import { CUSTOMER_FAQS } from '../../components/Faq/faqData';

// Public /faq page — full BestHand Customer FAQ.
export default function Faq() {
  return (
    <div style={{ ...wrap, padding: '40px 20px 64px', fontFamily: FONT }}>
      <h1 style={{ fontSize: 30, fontWeight: 800, color: INK, margin: '0 0 8px' }}>Frequently Asked Questions</h1>
      <p style={{ color: GREY, margin: '0 0 26px', fontSize: 16 }}>
        Everything you need to know about booking home services on BestHand.
      </p>
      <FaqAccordion items={CUSTOMER_FAQS} />
    </div>
  );
}
